import Vue from 'vue'
const isProd = process.env.NODE_ENV === 'production'

class Bus extends Vue {
  $emit (event, ...args) {
    if (isProd) {
      this._emitProd(event, ...args)
    } else {
      this._emitDev(event, ...args)
    }
  }
  _emitDev (event, ...args) {
    console.groupCollapsed(`%c Event => ${event}`, 'color: #bada55')
    console.trace()
    console.groupEnd()
    super.$emit(event, ...args)
  }
  _emitProd (event, ...args) {
    super.$emit(event, ...args)
  }
}

class BusPromise extends Bus {
  async $emitPromise (event, ...args) {
    const listeners = this._events[`promise-${event}`] || []

    return Promise.all(listeners
      .map((listener) => {
        return listener(...args)
      })
    )
  }
  $onPromise (event, cb) {
    this.$on(`promise-${event}`, cb)
  }
  $offPromise (event, cb) {
    this.$off(`promise-${event}`, cb)
  }
}

export default function (app) {
  app.$bus = new BusPromise({})
  Vue.use(() => {
    Object.defineProperties(Vue.prototype, {
      $bus: {
        get () {
          return app.$bus
        }
      }
    })
  })
}
